import React, {useEffect, useState} from "react";
import Dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import Link from 'next/link';

import InitializePage from '../../lib/server/page'

import { getPublishingLineByName, getCategoriesByPublishingLine, getCollectionsbyCategory} from "../../lib/api/common.jsx";

const Header = Dynamic(() => import('../../components/Layouts/Header'))
const HomeFooter = Dynamic(() => import('../../components/Layouts/HomeFooter'))
const SubscribeNewsLetter = Dynamic(() => import('../../components/common/subscribenewsletter'))
const ContentImage = Dynamic(() => import('../../components/common/ContentImage'))
const HeaderTag = Dynamic(() => import('../../components/meta'))


const Sello = (props) => {
    const {webTexts} = props;
    const [publishinglines, setPublishinglines] = useState(props?.publishinglines?.data);    
    const [publishinglinesCategory, setpublishinglinesCategory] = useState(props?.publishinglinesCategory?.data);
    const [collectionsbyCategory, setcollectionsbyCategory] = useState(props?.collectionsbyCategory?.data);
    const [catText, setcatText] = useState(props.selectedCategory ? props.selectedCategory.text : props?.publishinglinesCategory?.data[0].text);
    const [catSlug, setCatSlug] = useState(props.selectedCategory ? props.selectedCategory.slug : props?.publishinglinesCategory?.data[0].slug);
    const [catId, setcatId] = useState(props.selectedCategory ? props.selectedCategory.id : props?.publishinglinesCategory?.data[0].id);
    const [catName, setCatName] = useState(props.selectedCategory ? props.selectedCategory.category : props?.publishinglinesCategory?.data[0].category);
    const router = useRouter();

    
    useEffect(()=>{
        const {slug} = router.query;        
        const pLineSlug = slug[0]                
        
        
        _fetchData(); 
        
        async function _fetchData() {
            const requestData = { "publishingLine": pLineSlug }
                        
            let publishinglinesCategory = null;
            let collectionsbyCategory = null;
                    
            const publishinglines = await getPublishingLineByName(requestData);
            if(publishinglines?.responseCode == '201') {

                publishinglinesCategory = await getCategoriesByPublishingLine(publishinglines?.data.id);
                
                let categorySelected = publishinglinesCategory?.data[0];

                if(slug[1] !='' && slug[1] != undefined){
                    categorySelected = publishinglinesCategory?.data.find(cat => cat.slug == slug[1]);
                }                 

                collectionsbyCategory = await getCollectionsbyCategory(categorySelected?.id);

                setPublishinglines(publishinglines.data) ;
                setpublishinglinesCategory(publishinglinesCategory.data)
                setcollectionsbyCategory(collectionsbyCategory.data)

                setcatText(categorySelected.text);
                setCatSlug(categorySelected.slug);
                setcatId(categorySelected.id)                
                setCatName(categorySelected.category)     
            }            
        }                    
    },[router])
    
    const handleCatCollection = async (val) => {        
        /* setcatText(val.text);
        setCatSlug(val.slug);
        setcatId(val.id)
        setCatName(val.category)     

        const collectionsbyCategory = await getCollectionsbyCategory(val.id);
        if(collectionsbyCategory.responseCode == '201') {
            setcollectionsbyCategory(collectionsbyCategory?.data);
        } */
        router.push('/sellos/' + router.query.slug[0] +'/' + val.slug, undefined,{ shallow: true })
        //window.history.pushState(null, null, '/sellos/' + router.query.slug[0] +'/' + val.slug);
    }
    return (
        <>
            <Header page={'common'} menuSections={props.menu}/>			
            <HeaderTag title={`Colecciones ${catName} de ${publishinglines.publishingLine}`} description={`Descubre las categorias y colecciones de ${publishinglines.publishingLine} en ecc comics.`} url={`${props.host}${router.asPath.split('?')[0]}`}/>
            <div className="container main-container mt-50 catalogo mb-50">
                <div className="heading-wrap">
                    <div className="img-wrapper">
                        <ContentImage imageName={publishinglines?.logo} isImageComponent={false}/>
                    </div>
                    <h2 className="subheading">{publishinglines?.description}</h2>
                </div>
            </div>
            <div className="container main-container">
                <div className="nav-wrapper">
                    <div className="navigation-w">
                        <ul className="nav nav-tabs align-tab sellos">
                            {publishinglinesCategory?.map((val, i) => (
                            <li key={`tab-${i}`} className={catId===val.id?"nav-item active":"nav-item"} role="presentation"><a className={catId===val.id?"nav-link active":"nav-link"} href="#" data-bs-toggle="tab" type="button" role="tab" aria-selected="true" onClick={() => handleCatCollection(val)}>{val.category}</a></li>
                            ))}
                        </ul>
                        <div className="center-block"></div>
                        <div className="cat-select-tab-mob">
                            <select className="form-control btn2_cont nav" onChange={(val) => handleCatCollection(publishinglinesCategory.find(x => x.id == val.target.value))}>
                            {publishinglinesCategory?.map((val, i) => (
                                <option key={`form-${i}`} className={catId===val.id?"nav-link active":"nav-link"} data-bs-toggnpm run="true" dele="tab" type="button" role="tab" aria-selected="false" value={val.id} >{val.category}</option>
                            ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="tab-content">
                    <div className="cont-wrap tab-pane fade show active publishline" key={`col{i}`}>
                        <div className="catTitle">
                        <p>{catText}</p>
                        </div>
                        <div className="row">
                        {collectionsbyCategory && collectionsbyCategory?.length > 0 ? collectionsbyCategory?.map((val, i) => {
                                const link = `/catalogo/${props?.publishinglines?.data?.slug}/${catSlug}/${val?.slug.toLowerCase()}`;
                                
                                return (<Link key={`link-${i}`} passHref={true} href={link}>
                                        <div className="col-2">
                                            <div className="img-wrapper">
                                                <ContentImage imageName={val?.image} isImageComponent={false} eccImage={true}/>
                                            </div>
                                            <h2 className="subheading">{val?.collection}</h2>
                                            <p className="collection_text">{val?.text}</p>
                                        </div>
                                    </Link>
                                    )})
                                : <p>No hay categorias que mostrar</p>
                        }
                        </div>
                    </div>
                </div>
            </div>
            <div className="container line-container">
                <div className="line6"></div>
            </div>
            <SubscribeNewsLetter webTexts={webTexts}/>
            <HomeFooter />

        </>
    );
};

async function loadData(context){    
    const pLineSlug = context.query.slug;
    
    const requestData = { "publishingLine": pLineSlug[0] }
    const categorySlug = pLineSlug[1];

    let publishinglinesCategory = null;
    let collectionsbyCategory = null;
    let selectedCategory = null;

    const publishinglines = await getPublishingLineByName(requestData, context);

	
    if(publishinglines?.responseCode == '201') {

        publishinglinesCategory = await getCategoriesByPublishingLine(publishinglines?.data.id);

        if(categorySlug){
            selectedCategory = publishinglinesCategory?.data?.find(x => x.slug===categorySlug);
            if (selectedCategory){
                collectionsbyCategory = await getCollectionsbyCategory(selectedCategory?.id, context);    
            }
        }

        if(!collectionsbyCategory)
            collectionsbyCategory = await getCollectionsbyCategory(publishinglinesCategory?.data[0]?.id,context);
        
    }
  
    if(publishinglines?.responseCode == '404' || publishinglinesCategory != null && publishinglinesCategory?.responseCode == '404' || collectionsbyCategory != null &&collectionsbyCategory?.responseCode == '404') {
      return {
        notFound: true,
      }
    }
    return {publishinglines, publishinglinesCategory, collectionsbyCategory, selectedCategory }    
}

export async function getServerSideProps(context) {    
    return InitializePage(context,loadData, false)
}
export default React.memo(Sello);
